import { render } from "./ModalWrapper.component.vue?vue&type=template&id=f9e8c30c"
import script from "./ModalWrapper.component.vue?vue&type=script&lang=js"
export * from "./ModalWrapper.component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ASIP-Sante/g1/shared/santefr/web/modules/custom/sante_vuejs/vue-core/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sharedComponents/modals/ModalWrapper.component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f9e8c30c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f9e8c30c', __exports__)) {
    console.log('reload')
    api.reload('f9e8c30c', __exports__)
  }
  
  module.hot.accept("./ModalWrapper.component.vue?vue&type=template&id=f9e8c30c", () => {
    console.log('re-render')
    api.rerender('f9e8c30c', render)
  })

}


export default __exports__